<template>
  <div class="item-upload-progress w-100">
    <div class="item-upload-progress_title f-column">
      <div class="file-name">
        {{ filesLength }}
        {{ filesLength > 1 ? $t(`common.files`) : $t(`common.file`) }}
      </div>
      <div
        v-if="status === 'finished'"
        class="text-small"
      >
        {{
          filesLength > 1 ? $t(`analyze.upload.finished.files`) : $t(`analyze.upload.finished.file`)
        }}
      </div>
      <div
        v-else
        class="text-small"
      >
        {{ $t(`analyze.upload.status_${status}`) }}
      </div>
    </div>

    <ProgressLine
      data-tst="upload_loader"
      class="prgsline_no-animate mt-2"
      :style="`
      box-shadow: var(--menu-shadow);
       --end: ${totalProgress * 100}%;
       --radius: 2px;
       --radius-progress: 2px;
       --height: 4px;
       --clr-line: var(--clr-primary);
       --clr-back: var(--clr-black-2);
       `"
    />

    <div
      v-if="failed.length && totalProgress === 1"
      class="mt-3"
    >
      <div
        data-tst="upload_error_files"
        class="gw_btn text-medium gw_btn_text clr-error weight_500 csst"
        style="--clr-hover-white: rgba(245, 83, 83, var(--brighten-hover))"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
        @click.stop="copyFailedToClipboard"
      >
        <div class="mdi mdi-alert-circle-outline mr-1"></div>
        <div class="clr-error">
          {{ $t('analyze.upload.error_uploading_files', { num: failed.length }) }}
        </div>
        <div
          class="csst_content clr-white"
          style="position: fixed"
          :style="copied ? 'background: var(--clr-primary)' : ''"
          v-html="
            copied
              ? $t('messages.copied_to_clipboard')
              : $t('analyze.upload.copy_failed_to_clipboard')
          "
        />
      </div>
      <div
        v-if="totalProgress === 1"
        class="gw_btn gw_btn_primary weight_500 flex-1 mt-2"
        data-tst="upload_try_again"
        @click.stop="$emit('click:retry')"
      >
        {{ $t('analyze.upload.files_try_again') }}
      </div>
    </div>
  </div>
</template>

<script>
import ProgressLine from '@/components/lib/ProgressLine'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'UploadProgressItem',
  components: {
    ProgressLine,
  },
  mixins: [format_mix, float_mix],
  props: {
    filesLength: { default: () => 0 },
    totalProgress: { default: () => 0 },
    status: { default: () => 'progress' },
    failed: {
      default: () => [],
      // mock:
      // Array(100)
      //   .fill(null)
      //   .map(() => ({ file: { name: 'example.txt' } })),
    },
    // waiting
    // progress
    // finished
    // error
  },
  emits: ['click:retry'],
  data() {
    return {
      copied: false,
    }
  },
  methods: {
    copyFailedToClipboard() {
      const text = this.failed.map(item => item.file.name).join('\n')
      navigator.clipboard.writeText(text)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    },
  },
}
</script>
<style lang="scss" scoped>
.item-upload-progress {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  &_title {
    display: flex;
    position: relative;
    .file-name {
      font-size: 1rem;
      font-weight: 700;
      max-width: 80%;
    }
    .btn-cancel-upload {
      right: 0;
      position: absolute;
      top: -0.4rem;
    }
  }
}
</style>
